import { Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { TableJobs } from "./components/JobsTable/TableJobs";
import { useJobsContext } from "./context/JobsContext";
import { GetJobsStatus } from "./repositories/JobsRepository";

type Props = {};

export const Jobs = (prop: Props) => {
	const { state, actions } = useJobsContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getJobsFromAPI = async () => {
		setIsLoading(true);
		const resp = await GetJobsStatus();
		if (resp.ok) {
			actions.setJobs(resp.data);
			setIsLoading(false);
		} else {
			setError(resp.message ?? "Error loading jobs");
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getJobsFromAPI();
	}, []);

	return (
		<Grid container justifyContent="center" alignItems="center">
			<Grid item md={12} xs={12} style={{ margin: 0 }}>
				<div style={{ width: "100%", padding: "10px 0 20px" }}>
					<TableJobs isLoading={isLoading} getJobsFromAPI={getJobsFromAPI} />
				</div>
			</Grid>
			<ErrorModal error={error} onHide={() => setError("")} />
		</Grid>
	);
};
